export default __webpack_public_path__ + "static/media/AUD-2.c75e713f.jpg";